import React, { useEffect, useState,useRef } from 'react';

import BranchTable from '../../views/PartnerView/BranchTable';
import { useBranchContext } from '../Context/BranchContext';

const BranchTableComponent = () => {

  
    const [loading,setLoading] = useState(true);
    const didFetch = useRef(false); 
    const data = useRef('');
    const error = useRef('');
    const {FetchBranches,branches} = useBranchContext();
    
    const getData = async () => {
     
        try {
                await FetchBranches();
                setLoading(false); // Set loading to false once data is fetched
  
        
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
          getData();    
          didFetch.current = true; // Mark the API call as done
        }
      });
    
    
    return <div>
   {/* {loading && <div>Loading...</div>}*/}
    {!loading && branches !=null && <BranchTable/> }
    </div>
    // return <PartnerView Partnersdata={partners}/>
   
};

export default BranchTableComponent;
